export enum DispatchPermissions {
  PREVIEW_DISPATCH = 'dispatch.previewDispatch',
  GET_EVENTS = 'dispatch.getEvents',
  GET_LOCATION = 'dispatch.getLocation',
}
